import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, ConfirmDialogModule, GrowlModule } from 'primeng/primeng';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';

import { Select2Module } from 'ng2-select2';

// Service
import { HelperModule } from '../../../common/helper/helper.module';
import { UploadService } from '../../../common/services/Upload.service';
import { EvsAddressService } from '../../../common/services/EvsAddress.service';
// Component
import { Page401Component } from './page-error/page-401-component';
import { DashboardComponent } from './dashboard/dashboard.component'
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

import { CardModule } from '../../../layout/card';
import { BlockModule } from '../../../layout/block';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ContactModule } from './contact/contact.module';
import { SummaryComponent } from './report/summary.component';
import { TicketComponent } from './report/ticket.component';
import { ReportComponent } from './report/report.component';
import { ServiceComponent } from './report/service.component';
import { ContactComponent } from './report/contact.component';
import { ChatModule } from './chat/chat.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SettingsModule } from './setting/settings.module';
import { MailboxComponent } from './email/mailbox.component';
import {PopoverModule} from "ngx-popover";
import { MonitorComponent } from './monitor/monitor.component';
import { TagsInputModule } from 'ngx-tags-input/dist';
import { AnalyticComponent } from './analytic/analytic.component';
import { SearchComponent } from './search/search.component';
import { CampaignModule } from './campaign/campaign.module';
import { CustomerComponent } from './customer/customer.component';
import {SanitizedHtmlPipe} from './sanitized.pipe';
import {ChannelComponent} from './report/channel.component';
import {AgentComponent} from './report/agent.component';

declare var require: any;

export function highchartsFactory() {
    const hc = require('highcharts');
    const dd = require('highcharts/modules/drilldown');
    dd(hc);

    return hc;
}

@NgModule({
    imports: [CommonModule,
        ChartModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        GrowlModule,
        BrowserModule,
        HelperModule,
        CardModule,
        BlockModule,
        ModalModule.forRoot(),
        ContactModule,
        SettingsModule,
        Select2Module,
        ChatModule,
        BsDatepickerModule.forRoot(),
        InfiniteScrollModule,
        TooltipModule.forRoot(),
        PopoverModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        TagsInputModule.forRoot(),
        CampaignModule
    ],
    declarations: [

        Page401Component,
        DashboardComponent,
        SummaryComponent,
        TicketComponent,
        ReportComponent,
        ServiceComponent,
        ContactComponent,
        MailboxComponent,
        MonitorComponent,
        AnalyticComponent,
        SearchComponent,
        CustomerComponent,
        SanitizedHtmlPipe,
        ChannelComponent,
        AgentComponent
    ],
  exports: [TicketComponent, SanitizedHtmlPipe],
    providers: [UploadService, EvsAddressService, ConfirmationService,
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory
        }
    ],
    entryComponents: []
})
export class IContactModule { }



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/iContactModule.ts